export default "__VITE_ASSET__w_cUPKC$__"